import { string, object, number } from '@/utils/validations';

export default object({
  travel: object({
    cargoType: string().required(),
    cargoValue: number().moreThan(0, 'O valor deve ser maior que R$0,00').required(),
    originPlace: object().required(),
    destinationPlace: object().required(),
  }),
});
